import { useEnum } from "@/api/services/global/enum";
import { DATE_FORMAT } from "@/constants/datetime";
import { JobStatusTag } from "@/features/job/components/JobStatusTag";
import { JobTagList } from "@/features/job/components/JobTagList";
import { text } from "@/theme/colors";
import { FCC } from "@/types/common";
import { findLabelByValue } from "@/utils/object";
import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

type JobTitleProps = {
  title?: string | null | undefined;
  tag?: string[] | null | undefined;
  status?: string | null | undefined;
  createdAt?: string | null | undefined;
  updatedAt?: string | null | undefined;
};

export const JobTitle: FCC<JobTitleProps> = ({ title, tag, status, createdAt, updatedAt }) => {
  const { jobId } = useParams();
  const { data: jobStatusOptions } = useEnum("EJobStatus");
  const jobTitle = title ? title : "新規求人作成";

  const JobStatus = () => {
    if (status) {
      return <JobStatusTag status={status} title={findLabelByValue(jobStatusOptions, status)} variant="bold" />
    }
  };

  return (
    <TitleContainer>
      <Stack>
        <Stack>
          {jobId && <JobTagList tag={tag} createdAt={createdAt} />}
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
              <Typography variant="head24Bold">{jobTitle}</Typography>
              {jobId && <JobStatus />}
            </Stack>
            {/* <Button variant="outline" startIcon={<IconPrint />}>求人情報のPDF読み取り</Button> */}
          </Stack>
        </Stack>
        {jobId && (
          <Grid container gap={2}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="body14" color={text.secondary} sx={{ display: "flex", alignItems: "center" }}>
                登録日:
                <span style={{ marginLeft: 4 }}>{createdAt ? dayjs(createdAt).format(DATE_FORMAT) : ""}</span>
              </Typography>
              |
              <Typography variant="body14" color={text.secondary} sx={{ display: "flex", alignItems: "center" }}>
                更新日:
                <span style={{ marginLeft: 4 }}>{updatedAt ? dayjs(updatedAt).format(DATE_FORMAT) : ""}</span>
              </Typography>
            </Box>
            </Grid>
        )}
      </Stack>
    </TitleContainer>
  );
};

const TitleContainer = styled(Stack)`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: self-start;
  margin-bottom: 8px;
`;
